<div class="dl-panel" (click)="$event.stopPropagation()">
  <!-- Header -->
  <div class="tabla-menu-header">
    <span class="tabla-menu-titulo">
      <mat-icon>download</mat-icon>
      Descargas
      @if (totalCount) {
        <span class="dl-count">{{ totalCount.toLocaleString('es-AR') }}</span>
      }
    </span>
    @if (totalCount) {
      <div class="dl-header-acciones">
        <button
          irxBoton="peligro-texto"
          tamano="compacto"
          [disabled]="descargando"
          (click)="limpiarCompletadas()"
        >
          Limpiar completadas
        </button>
      </div>
    }
  </div>

  <!-- Lista (scrollable) -->
  <div class="dl-scroll">
    @if (totalCount) {
      @for (descarga of descargas; track descarga.token) {
        <div
          class="dl-item"
          [ngClass]="{
            'descarga-ready': descarga.ready,
            'descarga-pending': !descarga.ready && !descarga.error,
            'descarga-error': !!descarga.error,
          }"
          [class.clickable]="descarga.ready && !descargando"
          [style.opacity]="descargando && descarga.ready ? '0.5' : '1'"
          [style.pointer-events]="descargando ? 'none' : 'auto'"
          [class.irx-clickeable]="descarga.ready && !descargando"
          [attr.role]="descarga.ready ? 'button' : null"
          [attr.tabindex]="descarga.ready && !descargando ? 0 : null"
          (click)="descarga.ready && !descargando && descargarArchivo(descarga)"
          (keydown.enter)="
            descarga.ready && !descargando && descargarArchivo(descarga)
          "
        >
          <div class="dl-item-main">
            @if (descarga.ready) {
              <mat-icon class="dl-item-icon icon-ready">download_done</mat-icon>
            } @else if (descarga.error) {
              <mat-icon class="dl-item-icon icon-error">error_outline</mat-icon>
            } @else {
              <div class="dl-progress-wrap">
                <mat-progress-spinner
                  class="dl-progress-ring"
                  [diameter]="40"
                  [strokeWidth]="3"
                  [mode]="descarga.progreso ? 'determinate' : 'indeterminate'"
                  [value]="descarga.progreso || 0"
                ></mat-progress-spinner>
                <mat-icon class="dl-item-icon icon-pending dl-progress-icon">
                  hourglass_empty
                </mat-icon>
              </div>
            }
            <div class="dl-item-content">
              <h3 class="dl-titulo">
                {{ descarga.nombre || 'Descarga de video' }}
              </h3>
              <p class="dl-estado">
                @if (descarga.ready) {
                  Lista para descargar
                  @if (descarga.duracionMs) {
                    <span class="dl-dur">
                      · {{ formatDuracion(descarga.duracionMs) }}</span
                    >
                  }
                } @else if (descarga.error) {
                  {{ descarga.error }}
                } @else {
                  {{
                    descarga.progreso
                      ? 'Procesando ' + descarga.progreso + ' %'
                      : 'Procesando…'
                  }}
                }
              </p>
              <span class="dl-fecha">
                {{ fecha(descarga.fechaCreacion) }}
              </span>
            </div>
          </div>
          <div class="dl-item-acciones">
            @if (descarga.ready) {
              <button
                irxBotonIcono
                tono="primario"
                [tooltip]="
                  descarga.tipo === 'excel'
                    ? 'Descargar Excel'
                    : 'Descargar video'
                "
                [disabled]="descargando"
                (click)="descargarArchivo(descarga); $event.stopPropagation()"
              >
                <mat-icon>download</mat-icon>
              </button>
            }
            <button
              irxBotonIcono
              tono="peligro"
              tooltip="Eliminar"
              [disabled]="descargando"
              (click)="eliminarDescarga(descarga); $event.stopPropagation()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    } @else {
      <div class="dl-empty">
        <mat-icon>cloud_download</mat-icon>
        <span>No hay descargas activas</span>
      </div>
    }
  </div>
</div>
